var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"summary",attrs:{"src":_vm.videoInfo.summary}})])
}
var staticRenderFns = []

export { render, staticRenderFns }